import { Box, Button, Dialog, DialogContent, Typography } from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const SuccessModal = ({ open, onClose }: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as { from?: string } | null;
  const fromPage = state?.from;
  const params: any = new URLSearchParams(location.search);
  const locationId = params.get("locationId");
  // let qData: any = new URLSearchParams(location.search).get("data");

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => {
          navigate(`/search?locationId=${locationId}`, {
            state: { from: fromPage },
            replace: true, // avoids stacking duplicate entries
          });
          onClose();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box mt={1} textAlign="center">
            <CheckCircleIcon color="success" fontSize="large" />
            <Typography fontSize={14}>
              Thank you for submitting your request, our team will get in touch
              with you shortly.
            </Typography>

            <Button
              sx={{ mt: 3 }}
              onClick={() => {
                if (fromPage) {
                  navigate(`/search?locationId=${locationId}`, {
                    state: { from: fromPage },
                    replace: true, // avoids stacking duplicate entries
                  });
                } else {
                  navigate(-1);
                }
              }}
              variant="contained"
              color="primary"
              size="small"
            >
              Done
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default SuccessModal;
